import React, { useEffect } from "react";
import { auth } from "../../FirebaseConfig";
export default function LoggedOut(){
    // const auth = getAuth(app)

    useEffect(()=>{
        auth.signOut().then(() => {
            console.log(" signout successful")
        })
        .catch(e => {
            console.error(' an error occurred on logout', e)
        })
    },[])

    return (
        <React.Fragment>
            <div className={"container-fluid p-0 m-0 pt-2 min-vh-100"}>
                <div className={"row"}>
                    <div className={"col-12 text-center"}>
                        <p>You are logged out. To log in again, press the button below.</p>
                        <div className={"row"}>
                            <div className={"offset-4 col-4"}>
                                <a href={"/login"}>
                                    <button className={"btn btn-outline-primary"}>
                                        Log In
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

